import React from "react";
import { useNavigate } from "react-router-dom";
import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";
import { FaCreditCard } from "react-icons/fa";

const AgencyDashboard = () => {
  const navigate = useNavigate();
  const loggedInEmail = sessionStorage.getItem("userEmail");
  const handleLogout = () => {
    // Clear all session data
    sessionStorage.clear();
    // Show alert
    alert("You have been logged out successfully!");
    // Redirect to login page
    navigate("/agency-login");
  };


  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f4f6f8", display: "flex", flexDirection: "column", }}>
      {/* Header */}
      <header style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "15px 30px", backgroundColor: "#1e293b", color: "#fff", }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img src={A1} alt="Logo" style={{ width: "40px", height: "40px", borderRadius: "50%" }} />
          <h2 style={{ textTransform: "uppercase" }}>Agency Dashboard</h2>
        </div>
        <button onClick={handleLogout} style={{ padding: "10px 20px", backgroundColor: "#ef4444", border: "none", borderRadius: "5px", color: "#fff", cursor: "pointer", }}>Logout</button>
      </header>
      {/* Main Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          gap: "30px",
          alignItems: "center",
        }}
      >
        {/* Agency List */}
        <button
          onClick={() => navigate("/agency-list")}
          style={{
            width: "200px",
            height: "60px",
            fontSize: "18px",
            backgroundColor: "#3b82f6",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          📋 Agency List
        </button>

        {/* Offers */}
        {loggedInEmail === "admintaai@gmail.com" && (
          <button
            onClick={() => navigate("/agency-offers")}
            style={{
              width: "200px",
              height: "60px",
              fontSize: "18px",
              backgroundColor: "#10b981",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            🎁 Offers
          </button>
        )}

        {loggedInEmail === "admintaai@gmail.com" && (
          <button
            onClick={() => navigate("/agency-payment")}
            style={{
              width: "200px",
              height: "60px",
              fontSize: "18px",
              backgroundColor: "#f59e0b",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <FaCreditCard />
            Payment
          </button>
        )}
      </div>
      {/* Footer */}
      <footer style={{ textAlign: "center", padding: "12px", backgroundColor: "#1e293b", color: "#fff", fontSize: "14px", }}>
        © All Rights Reserved by e-Medha Technologies
      </footer>
    </div>
  );
};

export default AgencyDashboard;
